const loginPage = {
  fr: {
    loginPage: {
      signIn: 'Connexion',
    },
  },
  en: {
    loginPage: {
      signIn: 'Sign In',
    },
  },
};

export default loginPage;
